import { classes, cn } from '../../../utils/class-utils';

const baseStyles = classes(['animate-pulse', 'bg-[#DEDEDE]', 'rounded']);

interface SkeletonProps {
  /** Additional CSS classes to apply */
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return <div className={cn(baseStyles, className)} />;
}
